import React, { Component } from "react";
import ReactDOM from "react-dom";

// A modal confirmation, centred in the visible matrix: the matrix runs in its
// own iframe / WebView, so the viewport is exactly what staff can see, however
// far down the seats they have scrolled. Escape and a click outside cancel;
// the confirm button takes the focus, so Enter confirms. Without a
// cancelLabel it is a notice with a single button.
class ConfirmDialog extends Component {
  confirmButton = React.createRef();

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    if (this.confirmButton.current) this.confirmButton.current.focus();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape") this.props.onCancel();
  };

  render() {
    const { title, message, confirmLabel, cancelLabel, onConfirm, onCancel } =
      this.props;
    return ReactDOM.createPortal(
      <div className="confirm-dialog-backdrop" onClick={onCancel}>
        <div
          className="confirm-dialog"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-message"
          onClick={(event) => event.stopPropagation()}
        >
          <h2 id="confirm-dialog-title" className="confirm-dialog-title">
            {title}
          </h2>
          <p id="confirm-dialog-message" className="confirm-dialog-message">
            {message}
          </p>
          <div className="confirm-dialog-actions">
            {cancelLabel && (
              <button
                type="button"
                className="confirm-dialog-button"
                onClick={onCancel}
              >
                {cancelLabel}
              </button>
            )}
            <button
              type="button"
              ref={this.confirmButton}
              className="confirm-dialog-button confirm-dialog-button-primary"
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>,
      document.body,
    );
  }
}

export default ConfirmDialog;
